import { createAsyncThunk } from '@reduxjs/toolkit';
import { getWhatsAppSettings } from 'services/whatsAppMessaging';
import { IWhatsAppSettings } from 'services/whatsAppMessaging/types';

export const ThunkGetWhatsAppSettings = createAsyncThunk<IWhatsAppSettings | null>(
  'whatsAppMessaging/getSettings',
  async () => {
    try {
      const { data } = await getWhatsAppSettings();
      return data;
    } catch {
      return null;
    }
  },
);
